import { Observable } from 'rxjs/Observable';
import {observeCurrentUserProfile} from "../eventDataSourceUpgrades/observeCurrentUserProfile";
import { EventSource } from './eventSource';
import { observeProcessedEventAclRole$ } from '../eventDataSourceUpgrades/observeProcessedEventAclRole';

import 'rxjs/add/observable/interval'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/switchMap'

export class EventUser {
    private es: EventSource;
    private ds: any;
    constructor(eventSource: EventSource) {
      this.es = eventSource;
      this.ds = eventSource.getDatasource();
    }

    // todo change return type
    public observeUser(): Observable<any> {
      return new Observable(observer => {

        const listener = {
          onValue: val => observer.next(val),
          onError: err => (err.code !== "PERMISSION_DENIED") ? observer.error(err) : null
        };

        let l = observeCurrentUserProfile(this.ds, listener);
        observer.add(() => {
          this.ds._observers.splice(this.ds._observers.indexOf(observer), 1);
        })
      }).publishReplay().refCount()
    }

    public observeUserAcl(): Observable<any> {
      return observeProcessedEventAclRole$(this.es)
    }
}
